<template>
  <mdb-navbar color="special-color " expand="md" id="navbar2" dark>
    <mdb-navbar-brand href="#/map">
      <img src="@/assets/dtone_logo2.png" id="brand-image" />
    </mdb-navbar-brand>
    <mdb-navbar-toggler>
      <mdb-navbar-nav>
        <mdb-nav-item class="navbar-text navbar-align" href="#/map" active
          ><b>RECEIVER MAP</b></mdb-nav-item
        >
        <mdb-dropdown class="navbar-text">
          <mdb-dropdown-toggle
            :waves="false"
            class="text-white z-depth-0 px-3 "
            slot="toggle"
            tag="button"
            ><mdb-icon icon="cog" /> <b>SETTINGS</b></mdb-dropdown-toggle
          >
          <mdb-dropdown-menu>
            <mdb-dropdown-item class="options-item" @click="allowZoom()"
              ><span>{{
                zoom ? "Disallow Zoom" : "Allow Zoom"
              }}</span></mdb-dropdown-item
            >
            <mdb-dropdown-item
              class="options-item"
              @click="changeShowDetailsMethod()"
              >Show Details {{ showDetailsMethod }}</mdb-dropdown-item
            >
            <mdb-dropdown-item
              class="options-item"
              @click="showDtoneOffices()"
              >{{
                showOffices ? "Hide Dtone Offices" : "Show Dtone Offices"
              }}</mdb-dropdown-item
            >
          </mdb-dropdown-menu>
        </mdb-dropdown>
      </mdb-navbar-nav>
    </mdb-navbar-toggler>
  </mdb-navbar>
</template>

<script>
import {
  mdbNavbar,
  mdbNavbarBrand,
  mdbNavbarToggler,
  mdbNavbarNav,
  mdbNavItem,
  mdbDropdown,
  mdbDropdownMenu,
  mdbDropdownToggle,
  mdbDropdownItem
} from "mdbvue";
import {
  toggleZoom,
  showLocations,
  swapShowDetailsMethod
} from "../common/utilities/mapController.js";
export default {
  name: "Navbar",
  data() {
    return { showOffices: false, zoom: false, showDetailsMethod: "on_click" };
  },
  methods: {
    allowZoom() {
      this.zoom = !this.zoom;
      toggleZoom(this.zoom);
    },
    showDtoneOffices() {
      this.showOffices = !this.showOffices;
      showLocations(this.showOffices);
    },
    changeShowDetailsMethod() {
      if (this.showDetailsMethod == "on_click") {
        this.showDetailsMethod = "on_hover";
        swapShowDetailsMethod("on_click");
      } else {
        this.showDetailsMethod = "on_click";
        swapShowDetailsMethod("on_hover");
      }
    }
  },
  components: {
    mdbNavbar,
    mdbNavbarBrand,
    mdbNavbarToggler,
    mdbNavbarNav,
    mdbNavItem,
    mdbDropdown,
    mdbDropdownMenu,
    mdbDropdownToggle,
    mdbDropdownItem
  }
};
</script>
<style lang="scss" scoped>
#brand-image {
  height: 2rem;
  cursor: pointer;
}
#navbar2 {
  background-color: #3a464f !important;
}

.mr-auto,
.mx-auto {
  margin-left: auto !important;
  margin-right: 2.5rem !important;
  border: none !important;
  outline: none !important;
}
.navbar .nav-item {
  color: #fff !important;
  text-transform: uppercase;
  font-size: 0.8rem;
  font-weight: bold;
  letter-spacing: 1px;
  margin-right: 30px;
  overflow: visible;
  white-space: nowrap;
}
.navbar .nav-item a.nav-link {
  color: #fff !important;
}
.setting-icon {
  margin: 0px 5px;
}

.options-item {
  &:hover {
    background: rgb(201, 201, 201);
  }
}
.navbar-align {
  margin-top: 6px;
}
</style>
